import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { SetState } from "source/app/services/UI/State/SetState";

export function UpdateFilteredQuotes(searchText: string) {
    SetState(ESharedFunction.BookOfMind, { searchText });
}
